import { useMemo } from "react"
import {
  ButtonOverrides,
  FlexGrid,
  FlexGridItem,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { IS_MEZO_MAINNET, SIDEBAR_NAVIGATION_WIDTH } from "#/shared/constants"
import { useMobileScreen } from "#/shared/hooks"
import { BridgeAssetButton } from "#/ui/Button"

import DashboardHeaderAccount from "./DashboardHeaderAccount"
import DashboardHeaderExplorer from "./DashboardHeaderExplorer"
import DashboardHeaderTitle from "./DashboardHeaderTitle"

const bridgeAssetsButtonOverrides: ButtonOverrides = {
  BaseButton: {
    style: ({ $theme }) => ({
      marginRight: $theme.sizing.scale500,
    }),
  },
}

export default function DashboardHeader() {
  const isMobileScreen = useMobileScreen()
  const [css, theme] = useStyletron()

  const paddingInline = useMemo(
    () => (isMobileScreen ? theme.sizing.scale1000 : theme.sizing.scale1600),
    [isMobileScreen, theme],
  )

  return (
    <FlexGrid
      flexGridColumnCount={3}
      flexGridColumnGap={theme.sizing.scale500}
      paddingLeft={paddingInline}
      paddingRight={paddingInline}
      paddingTop={theme.sizing.scale800}
      paddingBottom={theme.sizing.scale800}
      alignItems="center"
      justifyContent="space-between"
      className={css({
        zIndex: 100,
        background: theme.colors.backgroundSecondary,
        position: "sticky",
        top: 0,
        left: isMobileScreen ? 0 : SIDEBAR_NAVIGATION_WIDTH,
        width: "100%",
      })}
    >
      <FlexGridItem>
        <DashboardHeaderTitle />
      </FlexGridItem>
      <FlexGridItem
        overrides={{
          Block: {
            style: () => ({ width: "auto", flexGrow: 0 }),
          },
        }}
      >
        {IS_MEZO_MAINNET && (
          <BridgeAssetButton overrides={bridgeAssetsButtonOverrides} />
        )}
        <DashboardHeaderExplorer />
      </FlexGridItem>
      <FlexGridItem
        overrides={{
          Block: {
            style: () => ({
              width: "auto",
              display: "inline-flex",
              flexGrow: 0,
            }),
          },
        }}
      >
        {!isMobileScreen && <DashboardHeaderAccount />}
      </FlexGridItem>
    </FlexGrid>
  )
}
